var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramNested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 336V464C512 490.51 490.51 512 464 512H336C309.49 512 288 490.51 288 464V432H176C123.062 432 80 388.938 80 336V224H48C21.49 224 0 202.51 0 176V48C0 21.49 21.49 0 48 0H176C202.51 0 224 21.49 224 48V176C224 202.51 202.51 224 176 224H144V336C144 353.656 158.344 368 176 368H288V336C288 309.49 309.49 288 336 288H464C490.51 288 512 309.49 512 336Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramNested);
export default __webpack_public_path__ + "static/media/diagram-nested.1aaf9705227820d21f6aa9204ed78cce.svg";
export { ForwardRef as ReactComponent };